import React, { useEffect, useState } from "react";
import "./DownLoadForm.css";
import { FaShieldAlt, FaTimes } from "react-icons/fa";

const countryOptions = [
  "United States", "Canada", "United Kingdom", "Australia", "India",
  "Germany", "France", "Singapore", "United Arab Emirates", "Brazil",
  "Japan", "South Korea", "Israel", "South Africa"
];

const DownloadForm = ({ whitepaperTitle, downloadPath, closeModal }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    country: "",
    phone: "",
    organization: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && closeModal();
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [closeModal]);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateForm = () => {
    const nextErrors = {};
    if (!formData.fullName.trim()) nextErrors.fullName = "Full Name is required.";
    if (!formData.email.trim()) {
      nextErrors.email = "Email Address is required.";
    } else if (!validateEmail(formData.email.trim())) {
      nextErrors.email = "Please enter a valid email.";
    }
    if (!formData.country) nextErrors.country = "Country is required.";
    return nextErrors;
  };

  const triggerDownload = () => {
    if (downloadPath) {
      const link = document.createElement("a");
      link.href = downloadPath;
      link.download = "Salus Product Description.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const nextErrors = validateForm();
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    closeModal();
    setTimeout(triggerDownload, 150);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="close-button" onClick={closeModal}>
          <FaTimes />
        </button>

        <FaShieldAlt className="modal-icon" />
        <h2 className="modal-title">Download {whitepaperTitle}</h2>

        <form onSubmit={handleSubmit}>
          {/* Full Name */}
          <div className="form-field">
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
            />
            {errors.fullName && <span className="field-error">{errors.fullName}</span>}
          </div>

          {/* Email */}
          <div className="form-field">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <span className="field-error">{errors.email}</span>}
          </div>

          {/* Country */}
          <div className="form-field">
            <select name="country" value={formData.country} onChange={handleChange}>
              <option value="">Select Country</option>
              {countryOptions.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
            {errors.country && <span className="field-error">{errors.country}</span>}
          </div>

          {/* Phone */}
          <div className="form-field">
            <input
              type="text"
              name="phone"
              placeholder="Phone Number (optional)"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          {/* Organization */}
          <div className="form-field">
            <input
              type="text"
              name="organization"
              placeholder="Organization (optional)"
              value={formData.organization}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="submit-btn">
            Download PDF
          </button>
        </form>
      </div>
    </div>
  );
};

export default DownloadForm;
